import { useMemo } from "react";
import styles from "./Table.module.scss";
import ReactPaginate from "react-paginate";
import { combineClasses } from "@/lib/utils";
import ArrowIcon from "../SVGComponents/ArrowIcon";
import { useSelector } from "react-redux";
import { PAGINATION } from "@/lib/constants";
import type { RootState } from "@/store/rootReducer";

interface PaginationProps {
  totalCount?: number | undefined;
  pageSelected?: number | undefined;
  setPageSelected: (page: number) => void;
  rowsPerPageValue?: number | undefined;
}

const Pagination = ({
  totalCount = 0,
  pageSelected,
  setPageSelected,
  rowsPerPageValue = PAGINATION.DEFAULT_ROWS_PER_PAGE,
}: PaginationProps) => {
  const { sidebarOpen } = useSelector((state: RootState) => state.global);
  const noOfPages = useMemo(() => Math.ceil(totalCount / rowsPerPageValue), [rowsPerPageValue, totalCount]);

  if (noOfPages <= 1) {
    return null;
  }

  const handlePageClick = (e: { selected: number }) => {
    setPageSelected(e.selected + 1);
  };

  return (
    <div className={combineClasses(styles.pagination, sidebarOpen && styles.sidebarOpen)}>
      <div className={styles.paginationRightSide}>
        <ReactPaginate
          breakLabel="..."
          breakClassName={styles.page}
          previousClassName={combineClasses(styles.page, styles.arrowBox, styles.paginationPrev)}
          previousLabel={<ArrowIcon className={combineClasses(styles.arrow, styles.previousArrow)} />}
          nextClassName={combineClasses(styles.page, styles.arrowBox, styles.paginationNext)}
          nextLabel={<ArrowIcon className={combineClasses(styles.arrow, styles.nextArrow)} />}
          renderOnZeroPageCount={null}
          pageCount={noOfPages}
          containerClassName={styles.paginationContainer}
          activeClassName={styles.activePage}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageClick}
          disabledClassName={styles.disabled}
          pageClassName={styles.page}
          forcePage={Math.max(0, Number(pageSelected || 1) - 1)}
        />
      </div>
    </div>
  );
};

export default Pagination;
